'use strict';

angular.module('TurneroApp').component('coAgendaPaso1', {
	bindings: {
		centroAtencionSeleccionado: '<',
		ctrlPadre: '='
	},
	controller: [
		 '$anchorScroll',
		 '$scope',
		 'agendaService',
		 'TurneroAppConstant',
		 'utilsService',
		 function ($anchorScroll, $scope, agendaService, TurneroAppConstant, utilsService) {
		 	var ctrl = this;
		 	ctrl.Estados = TurneroAppConstant.Estados.Agenda;
		 	ctrl.limpiarMemoria = function () {
		 		ctrl.Agenda = {
		 			Id_Agenda: null,
		 			N_Agenda: '',
		 			Id_Centro_Atencion: ctrl.centroAtencionSeleccionado.id,
		 			Imprime_Ticket: 'N',
		 			Codigo_Agenda: '',
		 			Id_Estado: 0
		 		}
		 	};

		 	$scope.$on('inicioAgendaPaso1_load', function (event, obj) {
		 		ctrl.limpiarMemoria();
		 		ctrl.Agenda.Id_Agenda = obj.Id_Agenda;
		 		ctrl.agendaNueva = obj.isNew;
		 		if (ctrl.Agenda.Id_Agenda) {
		 			agendaService.Get_Paso1({ 'id_agenda': ctrl.Agenda.Id_Agenda }).$promise.then(function (resultado) {
		 				ctrl.Agenda = resultado.Data;
		 				if (ctrl.Agenda.Id_Estado == TurneroAppConstant.Estados.Agenda.Habilitada) {
		 					agendaService.Traer_Cantidad_Autorizados({ 'id_agenda': ctrl.Agenda.Id_Agenda }).$promise.then(function (autorizados) {
		 						ctrl.ctrlPadre.AutorizadosAgendaRequeridos = (autorizados.Data == 0);
		 						ctrl.ctrlPadre.AutorizadosAgendaRequeridos ? ctrl.switchTab(3, ctrl.ctrlPadre.inicioAgendaPaso3) : '';
		 					}).catch(function (error) {
		 						utilsService.errores(error)
		 					})
		 				}


		 			}).catch(function (error) {
		 				utilsService.errores(error)
		 			});
		 		}
		 	});

            ctrl.cancelar = function (mostrarMensaje = false) {
                if (mostrarMensaje) {
                    ctrl.ctrlPadre.mostrarMensajeFinal();
                } else {
                    ctrl.limpiarMemoria();
                    ctrl.ctrlPadre.consultaAgendas(true);
                }
            };

		 	ctrl.switchTab = function (paso, funcion) {
		 	    var pasoActual = 1;
		 	    if (ctrl.Agenda.Id_Estado != 0) { //Se controla para que no pueda cambiar de tab cuando la agenda es NUEVA (todavia no está en PENDIENTE)
		 	        if (ctrl.Agenda.Id_Estado == TurneroAppConstant.Estados.Agenda.Pendiente && pasoActual > paso) {
		 	            ctrl.cambiarVista(funcion);
		 	        } else if (ctrl.Agenda.Id_Estado != TurneroAppConstant.Estados.Agenda.Pendiente) {
		 	            ctrl.cambiarVista(funcion);
		 	        }
		 	    }
		 	};

		 	// cambiar de vista. sobretodo para el boton atras.-
		 	ctrl.cambiarVista = function (funcion) {
		 		funcion(true, ctrl.Agenda.Id_Estado == TurneroAppConstant.Estados.Agenda.Pendiente, ctrl.Agenda.Id_Agenda);
		 	};

		 	ctrl.guardarPaso1 = function (paso_siguiente) {
		 		if (ctrl.ctrlPadre.readOnly) {
		 			ctrl.ctrlPadre.inicioAgendaPaso2(true, true, ctrl.Agenda.Id_Agenda);
		 		} else {
		 			utilsService.swalTitle('Procesando datos', 'info');
		 			if (ctrl.validarForm()) {
		 				if (!ctrl.Agenda.Id_Agenda) {
                            agendaService.save(ctrl.Agenda).$promise.then(function (result) {
                                swal.close();
		 						if (result.Data != null && result.Data != 0) {
		 							ctrl.Agenda.Id_Agenda = result.Data;
		 							ctrl.ctrlPadre.inicioAgendaPaso2(true, true, ctrl.Agenda.Id_Agenda);		 							
		 						}
		 					}).catch(function (error) {
		 						swal.close();
		 						utilsService.errores(error);
		 					});
		 				} else {
                            agendaService.Put_Agenda_Paso1(({ 'id': ctrl.Agenda.Id_Agenda }, ctrl.Agenda)).$promise.then(function (result) {
                                swal.close();
                                if (paso_siguiente) {                                    
		 							ctrl.ctrlPadre.inicioAgendaPaso2(true, ctrl.Agenda.Id_Estado == TurneroAppConstant.Estados.Agenda.Pendiente, ctrl.Agenda.Id_Agenda);
		 						} else {
                                    ctrl.cancelar(true);
		 						}
                            }).catch(function (error) {
                                swal.close();
		 						utilsService.errores(error);
		 					});
		 				}
		 			}
		 		}
		 	};

		 	ctrl.validarForm = function () {
		 		var isValid_nombre = false;
		 		var isValid_Codigo = false;
		 		if (/^[A-Za-zÁÉÍÓÚáéíóúÑñüÜ _1234567890]*$/.test(ctrl.Agenda.N_Agenda) && ctrl.Agenda.N_Agenda.length >= 6) {
		 			isValid_nombre = true;
		 		} else {
		 			swal({
		 				title: 'Error',
		 				text: 'El nombre de la agenda debe tener al menos 6 caracteres, y sólo puede contener letras, espacios y números.',
		 				type: 'warning',
		 				allowEscapeKey: false,
		 				allowOutsideClick: false,
		 				confirmButtonText: 'Aceptar'
		 			})
		 			return false;
		 		}
		 		if ((ctrl.Agenda.Imprime_Ticket == 'S') ? /^[A-Z]{1,3}$/.test(ctrl.Agenda.Codigo_Agenda) : !0) {
		 			isValid_Codigo = true;
		 		} else {
		 			swal({
		 				title: 'Error',
		 				text: 'Si desea utilizar tickets para los turnos, debe ingresar un código alfabético de hasta 3 caracteres.',
		 				type: 'warning',
		 				confirmButtonText: 'Aceptar',
		 				allowEscapeKey: false,
		 				allowOutsideClick: false
		 			})

		 		}
		 		return isValid_nombre && isValid_Codigo;
		 	};
		 }
	],
	template: require('./agenda_Paso1.html')
});



// WEBPACK FOOTER //
// ./app/components/agenda/agenda_Paso1Component.js